import ResendCid10 from './ResendCid10';

export default ResendCid10;
